module.exports = __webpack_public_path__ + "img/file-x-03.11d86e27.svg";